import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class ModuleAPI {

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/module/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (module, success, failure) => {
    fetch(Config.app.link + 'api/module', new Header('POST', module))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static saveField = (field, success, failure) => {
    fetch(`${Config.app.link}api/module/field`, new Header('POST', field))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static saveInnerField = (field, success, failure) => {
    fetch(`${Config.app.link}api/role/module/field`, new Header('POST', field))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deleteField = (fieldId, success, failure) => {
    fetch(`${Config.app.link}api/module/field/delete/${fieldId}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static listOption = (moduleNo, success, failure) => {
    fetch(`${Config.app.link}api/module/field/option/${moduleNo}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static saveOption = (field, success, failure) => {
    fetch(`${Config.app.link}api/module/field/option`, new Header('POST', field))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deleteOption = (fieldId, success, failure) => {
    fetch(`${Config.app.link}api/module/field/option/delete/${fieldId}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default ModuleAPI;